import React, { Component } from 'react';
import _ from 'lodash';

class AttemptsCount extends Component {

  render() {
    const { completeLiftingOrder } = this.props;

    return (
      <div className="attempts-count">
        {
          _.size(_.filter(completeLiftingOrder, (o) => o.attempt.result))
        }
        -
        {
          _.size(_.filter(completeLiftingOrder, (o) => !o.attempt.result))
        }
        /
        {
          _.size(completeLiftingOrder)
        }
      </div>
    );
  }
}

export default AttemptsCount;
